import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';
import { ReactComponent as RemoveFileIcon } from '../../../../../assets/icons/remove_file.svg';

interface RemoveFileProps {
  disabled?: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export function RemoveFile({ disabled, onClick }: RemoveFileProps) {
  const [t] = useTranslation();

  return (
    <button className="capture-action" data-for="removeFile" data-tip onClick={onClick} disabled={disabled}>
      <RemoveFileIcon />
      <ReactTooltip id="removeFile" place="bottom" effect="solid" className="tooltip d-flex flex-column" type="dark">
        <span>{t(`imageManagement.actions.removeFile`)}</span>
      </ReactTooltip>
    </button>
  );
}
